import {on} from 'delegated-events'

function setHiddenFieldsForChosenPayout(form: Element, payoutEl: Element) {
  const stripeIDField = form.querySelector<HTMLInputElement>('.js-sponsors-stripe-id')!
  const payoutStartDateUnixField = form.querySelector<HTMLInputElement>('.js-sponsors-payout-start-date-unix')!

  const stripeID = payoutEl.getAttribute('data-stripe-account-id')!
  stripeIDField.value = stripeID

  const payoutStartDateUnix = payoutEl.getAttribute('data-payout-start-date-unix')
  if (payoutStartDateUnix) {
    payoutStartDateUnixField.value = payoutStartDateUnix
  } else {
    payoutStartDateUnixField.value = ''
  }
}

// --- Legacy SelectMenuComponent handlers (:use_overlay_payout_selector feature flag off) ---

function updatePayoutMenuTextLegacy(form: Element, payoutInput: HTMLInputElement) {
  const chosenPayoutEl = form.querySelector('.js-sponsors-chosen-payout')!
  if (payoutInput.checked) {
    const payoutContainer = payoutInput.closest('.js-sponsors-stripe-payout-container')!
    const payoutTextEl = payoutContainer.querySelector('.js-sponsors-stripe-payout-text')!
    chosenPayoutEl.textContent = payoutTextEl.textContent
  } else {
    const defaultText = chosenPayoutEl.getAttribute('data-default-text')!
    chosenPayoutEl.textContent = defaultText
  }
}

function updateSubmitButton(form: Element, payoutInput: HTMLInputElement) {
  if (!payoutInput.checked) return

  const submitButton = form.querySelector<HTMLButtonElement>('.js-sponsors-generate-receipt-button')!
  if (submitButton.disabled) submitButton.disabled = false
}

function clearPreviousSelection(form: Element, selector: string) {
  const radioInputs = form.querySelectorAll<HTMLInputElement>(selector)

  for (const radio of radioInputs) {
    radio.checked = false
  }
}

on('change', '.js-sponsors-stripe-payout', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return

  setHiddenFieldsForChosenPayout(form, currentTarget)
  updatePayoutMenuTextLegacy(form, currentTarget as HTMLInputElement)
  updateSubmitButton(form, currentTarget as HTMLInputElement)
})

on('click', '.js-sponsors-stripe-payout', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return
  clearPreviousSelection(form, '.js-sponsors-payout-year')
})

on('change', '.js-sponsors-payout-year', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return

  updatePayoutMenuTextLegacy(form, currentTarget as HTMLInputElement)
  updateSubmitButton(form, currentTarget as HTMLInputElement)
})

on('click', '.js-sponsors-payout-year', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return
  clearPreviousSelection(form, '.js-sponsors-stripe-payout')
})

// --- New Overlay + TabPanels + ActionList handlers (feature flag on) ---

function updatePayoutMenuText(form: Element, text: string) {
  const chosenPayoutEl = form.querySelector('.js-sponsors-chosen-payout')!
  const labelEl = chosenPayoutEl.querySelector('.Button-label')
  if (labelEl) {
    labelEl.textContent = text
  } else {
    chosenPayoutEl.textContent = text
  }
}

function enableSubmitButton(form: Element) {
  const submitButton = form.querySelector<HTMLButtonElement>('.js-sponsors-generate-receipt-button')!
  if (submitButton.disabled) submitButton.disabled = false
}

function clearActiveItems(form: Element, selector: string) {
  const items = form.querySelectorAll<HTMLElement>(selector)
  for (const item of items) {
    item.setAttribute('aria-checked', 'false')
    const li = item.closest('li')
    if (li) {
      li.classList.remove('ActionListItem--navActive')
    }
  }
}

function setActiveItem(button: HTMLElement) {
  button.setAttribute('aria-checked', 'true')
  const li = button.closest('li')
  if (li) {
    li.classList.add('ActionListItem--navActive')
  }
}

function closeOverlay(form: Element) {
  const overlay = form.querySelector<HTMLElement>('.js-sponsors-payout-overlay')
  if (overlay) {
    overlay.hidePopover()
  }
}

on('click', '.js-sponsors-stripe-payout-item', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return

  const button = currentTarget as HTMLElement
  const payoutId = button.getAttribute('data-payout-id')
  const payoutText = button.getAttribute('data-payout-text')
  if (!payoutId || !payoutText) return

  // Clear year selections and set hidden field
  clearActiveItems(form, '.js-sponsors-payout-year-item')
  const payoutYearField = form.querySelector<HTMLInputElement>('input[name="payout_year"]')
  if (payoutYearField) payoutYearField.value = ''

  // Set payout hidden field
  const payoutIdField = form.querySelector<HTMLInputElement>('input[name="payout_id"]')
  if (payoutIdField) payoutIdField.value = payoutId

  // Set stripe account and start date
  setHiddenFieldsForChosenPayout(form, button)

  // Mark active and update UI
  clearActiveItems(form, '.js-sponsors-stripe-payout-item')
  setActiveItem(button)
  updatePayoutMenuText(form, payoutText)
  enableSubmitButton(form)
  closeOverlay(form)
})

on('click', '.js-sponsors-payout-year-item', ({currentTarget}) => {
  const form = currentTarget.closest('.js-sponsors-payout-receipt-form')
  if (!form) return

  const button = currentTarget as HTMLElement
  const payoutYear = button.getAttribute('data-payout-year') || ''
  const payoutText = button.getAttribute('data-payout-text') || ''

  // Clear payout selections and hidden fields
  clearActiveItems(form, '.js-sponsors-stripe-payout-item')
  const payoutIdField = form.querySelector<HTMLInputElement>('input[name="payout_id"]')
  if (payoutIdField) payoutIdField.value = ''
  const stripeIDField = form.querySelector<HTMLInputElement>('.js-sponsors-stripe-id')
  if (stripeIDField) stripeIDField.value = ''
  const startDateField = form.querySelector<HTMLInputElement>('.js-sponsors-payout-start-date-unix')
  if (startDateField) startDateField.value = ''

  // Set year hidden field
  const payoutYearField = form.querySelector<HTMLInputElement>('input[name="payout_year"]')
  if (payoutYearField) payoutYearField.value = payoutYear

  // Mark active and update UI
  clearActiveItems(form, '.js-sponsors-payout-year-item')
  setActiveItem(button)
  updatePayoutMenuText(form, payoutText)
  enableSubmitButton(form)
  closeOverlay(form)
})
